module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_chocolatey_peanuts-c204c2fc.png";